module.exports = __webpack_public_path__ + "img/winerackdog27.d44499b5.jpg";